import React from 'react'
import { css, cx } from '@emotion/css'
import { mainSectionHeaderCss } from '../../legacy-design-system/text'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

const getColumnTitleStyle = (position: ColumnTitlePosition) =>
  cx(
    mainSectionHeaderCss,
    css`
      display: flex;
      justify-content: ${position};
      margin-bottom: 20px;
    `
  )

type ColumnTitlePosition = 'center' | 'flex-start'

export function FlowMapColumnTitle({
  titleI18n,
  position = 'center'
}: {
  readonly titleI18n: string
  readonly position?: ColumnTitlePosition
}) {
  return (
    <ContrastFormattedMessage id={titleI18n}>
      {(columnTitle) => (
        <div className={getColumnTitleStyle(position)}>
          {columnTitle.toUpperCase()}
        </div>
      )}
    </ContrastFormattedMessage>
  )
}
